// src/services/api/MessagingApi.tsx
import { BaseAPI } from "./BaseApi";

export class MessagingAPI extends BaseAPI {
  constructor() {
    super("");
  }

  async createConversation(targetUserId: string) {
    return this.request<any>("/api/messaging/conversations", {
      method: "POST",
      body: JSON.stringify({ targetUserId }),
      auth: true,
    });
  }

  async listConversations(cursor?: string) {
    const params = new URLSearchParams();
    if (cursor) params.append("cursor", cursor);

    const queryString = params.toString();
    return this.request<any>(`/api/messaging/conversations${queryString ? `?${queryString}` : ""}`, {
      method: "GET",
      auth: true,
    });
  }

  async sendMessage(conversationId: string, body: string) {
    return this.request<any>(`/api/messaging/conversations/${conversationId}/messages`, {
      method: "POST",
      body: JSON.stringify({ body }),
      auth: true,
    });
  }

  async getMessages(conversationId: string, cursor?: string) {
    const params = new URLSearchParams();
    if (cursor) params.append("cursor", cursor);

    const queryString = params.toString();
    return this.request<any>(`/api/messaging/conversations/${conversationId}/messages${queryString ? `?${queryString}` : ""}`, {
      method: "GET",
      auth: true,
    });
  }

  async deleteMessage(messageId: string) {
    return this.request<any>(`/api/messaging/messages/${messageId}`, {
      method: "DELETE",
      auth: true,
    });
  }

  async markRead(conversationId: string) {
    return this.request<any>(`/api/messaging/conversations/${conversationId}/read`, {
      method: "POST",
      auth: true,
    });
  }
}
